import React from 'react';
//import PropTypes from 'prop-types';

import * as api from '_core/utils/api';
import { API_METHOD } from 'basic/config';
import { API_ERROR } from 'config';

import { ProfileSecurityFormView } from './ProfileSecurityFormView';


const RawProfileSecurityForm = (props) => {
  const [protections, setProtections] = React.useState();
  const [securityInfo, setSecurityInfo] = React.useState();
  
  React.useEffect(() => {
    api.getClientVisitorProtection()
      .then(setProtections)
      .catch((error) => {
        console.error(error);
        setProtections([]);
      });
    
    api.request(API_METHOD.CLIENT_SECURITY_INFO, {})
      .then(setSecurityInfo)
      .catch((error) => {
        console.error(error);
        setSecurityInfo({});
      });
  }, []);
  
  
  return (
    <ProfileSecurityFormView
      protections={protections}
      securityInfo={securityInfo}
      setSecurityInfo={setSecurityInfo}
    />
  );
};

RawProfileSecurityForm.defaultProps = {};

RawProfileSecurityForm.propTypes = {
};

export const ProfileSecurityForm = RawProfileSecurityForm;
